import FetchService from "./Shared/FetchService";
export default class PersonPhoneService {
    static getPhoneList(affiliationId) {
        return FetchService.getSingleResponse("/aviso/advisor/phoneList", {
            affiliationId,
        });
    }
    static togglePhoneVerified(personPhoneId) {
        return FetchService.postSingleResponse("/aviso/advisor/togglePhoneVerified", { id: personPhoneId });
    }
    static setSmsEnabled(personPhoneId, enabled) {
        // Weirdly, this expects enabled to be true, false or null.
        // We need to map enabled to these values.
        let status = null;
        if (enabled === 1 || enabled === "1") {
            status = "true";
        }
        if (enabled === 0 || enabled === "0") {
            status = "false";
        }
        if (enabled === null || enabled === "null") {
            status = "null";
        }
        return FetchService.postSingleResponse("/aviso/advisor/toggleSmsEnabled", {
            id: personPhoneId,
            status,
        });
    }
}
